module.exports = __webpack_public_path__ + "img/app_brand_cannalytics.c2b1041b.svg";